<template>
  <router-link tag="button" :to="{ name: 'Profile edit' }" class="large" :class="type">
    <img src="@/assets/icons/edit.svg" alt="" v-if="type === 'primary'" />
    <img src="@/assets/icons/edit-dark.svg" alt="" v-else />
    <span>{{ $t('btn-edit-profile') }}</span>
  </router-link>
</template>

<script>
export default {
  name: 'btn-edit-profile',
  props: {
    type: {
      default: 'primary',
    },
  },
}
</script>
